import * as React from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import ActivityQuestionCategoryDTO from 'src/models/activity/ActivityQuestionCategoryDTO';
import ActivityApiController from 'src/api/ActivityApiController';
import { message, Button, Modal, Tooltip } from 'antd';


export interface ActivityQuestionCategoriesProps extends LocalizeContextProps {
    activityId: number;
    updateShouldRefreshTable: () => void;
}

interface ActivityQuestionCategoriesState {
    loading: boolean;
    tableRecords: ActivityQuestionCategoryDTO[];
    formRedirect: boolean;
}

class ActivityQuestionCategories extends React.Component<ActivityQuestionCategoriesProps, ActivityQuestionCategoriesState> {
    private dataTableRef: DataTable<ActivityQuestionCategoryDTO>;

    constructor(props: ActivityQuestionCategoriesProps) {
        super(props);
        bindAllOfThis(this, ActivityQuestionCategories.prototype);

        this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
    }

    private deleteActivityQuestionCategory(activityQuestionCategoryId: number): void {
        let ref = this.dataTableRef;
        let updateShouldRefreshTable = this.props.updateShouldRefreshTable;
        let translate: (id: any) => any = this.props.translate;

        Modal.confirm({
            title: translate('admin.activityQuestionCategories.confirmDelete'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            content: translate('admin.activityQuestionCategories.confirmContent'),
            onOk() {
                ActivityApiController.deleteActivityQuestionCategory(activityQuestionCategoryId).then(result => {
                    message.success(translate('admin.activityQuestionCategories.messageDelete'));
                    ref.refresh();
                    updateShouldRefreshTable();
                }).catch(e => {
                    message.error(this.props.translate('admin.activityQuestionCategories.messageDeleteError'));
                });
            },
        });
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<ActivityQuestionCategoryDTO>) => void): void {
        this.setState({ loading: true });

        ActivityApiController.getActivityQuestionCategoryTableData(requestState, this.props.activityId)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results ? results.data.results : [];

                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });

                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<ActivityQuestionCategoryDTO>[] {
        let editLink = (text, record: ActivityQuestionCategoryDTO) => Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY_QUESTION_CATEGORY, this.props.activityId, record.activityQuestionCategoryId);

        return [
            DataTable.StandardColumns.Text('admin.activityQuestionCategories.columnHeader1', 'titleText'),
            DataTable.StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: (text, record, index) => {
                        return (
                            <Tooltip placement="bottom" title={this.props.translate('admin.common.deleteColumnHeader')} arrowPointAtCenter>
                                <Button shape="circle" icon="delete" onClick={() => this.deleteActivityQuestionCategory(record.activityQuestionCategoryId)} />
                            </Tooltip>
                        );
                    }
                }
            }
        ];
    }

    render() {
        if (this.state.formRedirect) {
            return <Redirect to={Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY_QUESTION_CATEGORY, this.props.activityId, 0)} push />;
        }

        return (
            <div>
                <h2>{this.props.translate('admin.activityQuestionCategories.tableHeader')}</h2>
                <DataTable
                    ref={ref => this.dataTableRef = ref}
                    serverSide={true}
                    tableProps={{ rowKey: 'activityQuestionCategoryId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButton('admin.activityQuestionCategories.addButton', () => { this.setState({ formRedirect: true }); }),
                        new DataTableButtonReset()
                    ]} />
            </div>
        );
    }
}

export default withLocalize(ActivityQuestionCategories as any) as any;



// WEBPACK FOOTER //
// ./src/pages/admin/ActivityQuestionCategories.tsx